import to from "await-to-js";
import { t } from "i18next";
import React, { useContext } from "react";

import { DownloadOutlined } from "@ant-design/icons";
import { ModalsContext } from "../../../../../../context/modals.context";
import { ministryService } from "../../../../../../modules/ministry/ministry.service";
import { IDozvolaZahteviDostavljeniDokaziProps } from "../../../../../../modules/ministry/ministry.types";
import { downloadFile } from "../../../../../../utils/fileDownload";
import { toastService } from "../../../../../../utils/toast.service";
import style from "./DocumentReadOnly.module.scss";

interface IDocumentReadOnlyProps {
  data: IDozvolaZahteviDostavljeniDokaziProps | null;
  dozvolaZahtevId?: number | null;
  tipDokumentaId?: number | null;
  title: string;
  disabled?: boolean;
  tip: number;
  isPoreska?: boolean;
  dokumentName?: string;
}

export const DocumentReadOnly: React.FC<IDocumentReadOnlyProps> = ({
  data,
  dozvolaZahtevId,
  tipDokumentaId,
  title,
  disabled,
  tip,
  isPoreska,
  dokumentName,
}) => {
  const { setError } = useContext(ModalsContext);

  const createDohvatiDokument = async () => {
    const [err, res] = await to(
      ministryService.createDohvatiDokument({ documentId: data?.id as any })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    toastService.success("TOAST.DOWNLOAD_SUCCESS");
    downloadFile(
      res.data.data,
      dokumentName || "dokument",
      res.data.format as any
    );
  };

  const poreskaDohvatiDokument = async () => {
    const [err, res] = await to(
      ministryService.poreskaDohvatiDokument({
        dozvolaZahtevId: dozvolaZahtevId ? dozvolaZahtevId : null,
        tipDokumentaId: tipDokumentaId ? tipDokumentaId : null,
      })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    toastService.success("TOAST.DOWNLOAD_SUCCESS");
    downloadFile(
      res.data.data as any,
      dokumentName || "dokument",
      res.data.format as any
    );
  };

  const handleUslov = () => {
    if (tip === 1 && data?.vrednostUslova)
      return t("AKCIZNE_DOZVOLE.ISPUNJAVA");
    else if (tip === 1 && data?.vrednostUslova === false)
      return t("AKCIZNE_DOZVOLE.NE_ISPUNJAVA");
    if (tip === 2 && data?.vrednostUslova)
      return t("AKCIZNE_DOZVOLE.NE_VODI_SE_KRIVICNI_POSTUPAK");
    else if (tip === 2 && data?.vrednostUslova === false)
      return t("AKCIZNE_DOZVOLE.POKRENUT_KRIVICNI_POSTUPAK");
    if (tip === 4 && data?.vrednostUslova)
      return t("AKCIZNE_DOZVOLE.NIJE_POKRENUT_POSTUPAK");
    else if (tip === 4 && data?.vrednostUslova === false)
      return t("AKCIZNE_DOZVOLE.POKRENUT_JE_POSTUPAK");
    if (tip === 6 && data?.vrednostUslova)
      return t("AKCIZNE_DOZVOLENE.VODI_SE_KRIVICNI_POSTUPAK");
    else if (tip === 6 && data?.vrednostUslova === false)
      return t("AKCIZNE_DOZVOLE.POKRENUT_KRIVICNI_POSTUPAK");
    if (tip === 7 && data?.vrednostUslova)
      return t("AKCIZNE_DOZVOLE.IZVRSEN_POPIS");
    else if (tip === 7 && data?.vrednostUslova === false)
      return t("AKCIZNE_DOZVOLE.NIJE_IZVRSEN_POPIS");
  };

  return (
    <div className={style.mainContainer}>
      <div className={style.title}>{title}</div>
      <div
        className={style.documentTitle}
        onClick={() =>
          isPoreska ? poreskaDohvatiDokument() : createDohvatiDokument()
        }
      >
        {data?.dokumentUrl ? <DownloadOutlined /> : null}{" "}
        {data?.dokumentUrl || ""}
      </div>
      {/*
      Temporary removal
      <div className={style.radioContainer}>
        {disabled ? null : (
          <span className={`${style.fontSize} pl-10`}>{handleUslov()}</span>
        )}{" "}
      </div> */}
    </div>
  );
};
